<nav class="navbar d-flex fixed-top bg-primary p-0">
  <div>
    <ng-content select="[header-left]"></ng-content>
  </div>
  <div class="me-auto">
    <ng-content select="[header-brand]"></ng-content>
  </div>
  <div class="mx-auto">
    <ng-content select="[header-between]"></ng-content>
  </div>
  <div class="ms-auto">
    <ng-content select="[header-right]"></ng-content>
  </div>
</nav>